import { ConcessionsApplicationFurtherReviewRequiredPopupQuestion } from "../interfaces/concessions-application-further-review-required-popup-question.interface";

export class ConcessionsApplicationFurtherReviewRequiredRequest implements ConcessionsApplicationFurtherReviewRequiredPopupQuestion {
    constructor(
        public id: string,
        public reviewReason: string
    ) { }
}